import axios from 'axios';
import { auth } from '../firebase';
import { safeRemoveItem } from '../utils/storageUtils';

const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor to attach token before each request
// This relies on the token being in localStorage, consistent with AuthContext
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 Unauthorized
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn('[apiClient] 401 Unauthorized detected. Clearing session.');
      safeRemoveItem('token');
      safeRemoveItem('tokenExpiry');
      try {
        if (auth) auth.signOut().catch(() => {});
      } catch (_) {}
      window.dispatchEvent(new Event('auth:unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default apiClient;
